{
  "user": {
    "profile": "Профиль",
    "logout": "Выход"
  },
  "changeRequest": {
    "title": "Запросы на изменение",
    "assignedToMe": "Проверка назначена на меня"
  },
  "search": {
    "placeholder": "Поиск",
    "nothingFound": "Ничего не найдено",
    "loading": "Поиск...",
    "mode": {
      "both": "Поиск и выбор",
      "select": "Выбор",
      "search": "Поиск"
    },
    "hint": {
      "title": "Подсказки",
      "drill": "далее",
      "search": "поиск",
      "open": "перейти",
      "back": "назад"
    },
    "groups": {
      "navigation": "Навигация",
      "dashboards": "Дашборды",
      "attributes": "Атрибуты"
    },
    "sections": {
      "recent": "Недавние",
      "results": "Результаты"
    },
    "recent": {
      "remove": "Удалить"
    }
  },
  "notification": {
    "title": "Уведомления",
    "status": {
      "new": "Новые",
      "viewed": "Прочитанные"
    },
    "checkViewed": "Отметить как прочитанное",
    "viewed": "Прочитано",
    "notificationLink": "Менеджер уведомлений"
  }
}